import { combineReducers } from 'redux';

import guarantors from './requests/guarantors-req';
import createGuarantor from './requests/create-guarantor-req';
import updateGuarantor from './requests/update-guarantor-req';
import selectedGuarantor from './requests/selected-guarantor';

export default combineReducers({
  guarantors,
  createGuarantor,
  updateGuarantor,
  selectedGuarantor,
});



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/index.js